// Global Instructions Rule Applied!

import React, { forwardRef } from 'react'
import { Input, type InputRef } from 'antd'
import { InputSize, FieldValue, textFieldValue } from '../types.ts'

export interface TextInputProps {
  value: FieldValue
  onChange: (value: string) => void
  onKeyDown?: (e: React.KeyboardEvent) => void
  size?: InputSize
  status?: 'error' | 'warning'
  placeholder?: string
  maxLength?: number
  minLength?: number
  pattern?: string
  autoFocus?: boolean
}

export const TextInput = forwardRef<InputRef, TextInputProps>(
  (
    { value, onChange, onKeyDown, size = 'small', status, placeholder, maxLength, minLength, pattern, autoFocus },
    ref
  ) => {
    return (
      <Input
        ref={ref}
        value={textFieldValue(value)}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        size={size}
        status={status}
        placeholder={placeholder}
        maxLength={maxLength}
        minLength={minLength}
        pattern={pattern}
        style={{ width: '100%' }}
        autoFocus={autoFocus}
      />
    )
  }
)

TextInput.displayName = 'TextInput'
